// remap jQuery to $.
(function($) {
    // trigger when page is ready.
    $(document).ready(function() {
        function initializeHeroBlock() {
            // Background video play/pause button actions
            let bg_vids = document.querySelectorAll(".video-bg");
            for(let i = 0; i < bg_vids.length; i++){
                let vid = bg_vids[i];
                let vid_parent = vid.parentNode.parentNode.parentNode;
                let pause_button = vid_parent.querySelector(".video-play-pause");
                function vidFade(vid) {
                    vid.classList.add("stopfade");
                }
                function vidPlay(vid, pause_button) {
                    vid.play();
                    pause_button.innerHTML = "Pause video";
                    pause_button.classList.add("active");
                    pause_button.setAttribute("title", "Pause video");
                    pause_button.setAttribute("aria-pressed", "true");
                }
                function vidPause(vid, pause_button) {
                    vid.pause();
                    pause_button.innerHTML = "Play video";
                    pause_button.classList.remove("active");
                    pause_button.setAttribute("title", "Play video");
                    pause_button.setAttribute("aria-pressed", "false");
                }
                if (vid && pause_button) {
                    vid.addEventListener("ended", function() {
                        // only functional if "loop" is removed
                        vidPause(vid, pause_button);
                        // to capture IE10
                        vidFade(vid);
                    });
                    if (window.matchMedia("(prefers-reduced-motion)").matches) {
                        vid.removeAttribute("autoplay");
                        vidPause(vid, pause_button);
                    } else vidPlay(vid, pause_button);
                    pause_button.addEventListener("click", function() {
                        vid.classList.toggle("stopfade");
                        if (vid.paused) vidPlay(vid, pause_button);
                        else vidPause(vid, pause_button);
                    });
                }
            }
        // //video modal
        // let video_modal_show_btn = document.querySelector('.show-video-modal');
        //
        // if (video_modal_show_btn) {
        // 	video_modal_show_btn.addEventListener('click', (e) => {
        // 		document.documentElement.classList.add('video-modal-visible');
        // 		e.preventDefault();
        // 	});
        // }
        //
        // const modal = document.querySelectorAll('.video-modal');
        // for (let i = 0; i < modal.length; i++) {
        // 	if (modal[i]) {
        //
        // 		const modal_close = modal[i].querySelector('.close-video-modal');
        // 		const ytVideo = modal[i].querySelector('iframe');
        // 		let src = ytVideo.src;
        //
        // 		['click', 'touchend'].forEach(function(event) {
        // 			modal[i].addEventListener(event, onModalClose, false);
        // 			const modal_content = modal[i].querySelector('.video-modal-content');
        // 			modal_content.addEventListener(event, function(event) {
        // 				event.stopPropagation()
        // 			}, false);
        // 		});
        //
        // 		function onModalClose()
        // 		{
        // 			document.documentElement.classList.remove('video-modal-visible');
        // 			// const videoSrc = ytVideo.src;
        // 			// ytVideo.src = videoSrc;
        // 		}
        // 	}
        // }
        }
        initializeHeroBlock();
        // Initialize dynamic block preview (editor).
        if (window.acf) window.acf.addAction("render_block_preview/type=home-hero", initializeHeroBlock);
    });
})(window.jQuery);


//# sourceMappingURL=block-home-hero.js.map
